
export default {
  name: 'PageLandOwnersIndex',

  head() {
    return {
      title: 'Land Owners',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'We are looking for new sites across the UK and offering competitive rates of up to £1,000 per acre per annum'
        }
      ]
    }
  },

  computed: {
    compHero() {
      return {
        title: 'Land Owners',
        image: require('~/assets/images/backgrounds/land-owners-hero.jpg'),
        alt: 'Paddock fencing'
      }
    }
  },

  mounted() {
    window.dataLayer = window.dataLayer || []

    function gtag() {
      window.dataLayer.push(arguments)
    }

    gtag('js', new Date())
    gtag('config', 'AW-10969678433')
  },

  methods: {
    contactSubmitLand() {
      this.$modal.open('land-owners/submit-land')
    },

    contact() {
      this.$modal.open('land-owners/land-owner-contact')
    }
  }
}
